import type { LoopConfig } from '../animation/types'

export function calculateLoopEffect(
  charX: number,
  charY: number,
  time: number,
  config: LoopConfig
): { offsetX: number; offsetY: number } {
  const { radius, speed, pathType } = config

  const phaseOffset = (charX + charY) * 0.02
  const t = time * speed + phaseOffset

  let offsetX = 0
  let offsetY = 0

  switch (pathType) {
    case 'circle':
      offsetX = Math.cos(t * Math.PI * 2) * radius
      offsetY = Math.sin(t * Math.PI * 2) * radius
      break

    case 'spiral': {
      const spiralRadius = radius * (0.5 + 0.5 * Math.sin(t * 0.5))
      offsetX = Math.cos(t * Math.PI * 2) * spiralRadius
      offsetY = Math.sin(t * Math.PI * 2) * spiralRadius
      break
    }

    case 'figure8':
      offsetX = Math.sin(t * Math.PI * 2) * radius
      offsetY = Math.sin(t * Math.PI * 4) * radius * 0.5
      break
  }

  return { offsetX, offsetY }
}

export class LoopEffect {
  private config: LoopConfig
  private time = 0

  constructor(config: Partial<LoopConfig> = {}) {
    this.config = {
      radius: 3,
      speed: 1,
      pathType: 'circle',
      ...config,
    }
  }

  update(deltaTime: number): void {
    this.time += deltaTime
  }

  calculate(charX: number, charY: number): { offsetX: number; offsetY: number } {
    return calculateLoopEffect(charX, charY, this.time, this.config)
  }

  setConfig(config: Partial<LoopConfig>): void {
    this.config = { ...this.config, ...config }
  }

  getConfig(): LoopConfig {
    return { ...this.config }
  }

  reset(): void {
    this.time = 0
  }
}

export function createLoopConfigFromSettings(
  radius: number = 3,
  speed: number = 1
): LoopConfig {
  return {
    radius,
    speed,
    pathType: 'circle',
  }
}
